import React from "react";
import PropTypes from "prop-types";
import { Info } from "lucide-react";

const EventHeatMapClusterHint = ({ t }) => (
  <div className="event-heatmap__cluster-hint">
    <Info size={16} />
    {t.clusterZoomHint}
  </div>
);

EventHeatMapClusterHint.propTypes = {
  t: PropTypes.object.isRequired,
};

export default EventHeatMapClusterHint;
